export { default } from './CloseButton.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Notification/CloseButton/index.js